module.exports = __webpack_public_path__ + "static/stylish-female-glasses-looking-happy-410d9928085b38af628f1f0d880aba4a.png";